"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rectIsInRect = void 0;
var rectangle_1 = require("../../types/record/rectangle");
/**
 * @description innerRectがouterRectに含まれているかどうか
 */
var rectIsInRect = function (innerRect, outerRect) {
    return outerRect.top <= innerRect.top &&
        outerRect.left <= innerRect.left &&
        (0, rectangle_1.right)(innerRect) <= (0, rectangle_1.right)(outerRect) &&
        (0, rectangle_1.bottom)(innerRect) <= (0, rectangle_1.bottom)(outerRect);
};
exports.rectIsInRect = rectIsInRect;
